


import SearchIcon from 'components/Shared/icons/search';
import { Disclosure, Listbox } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/20/solid';
import { useEffect, useState } from 'react';
import { DGACheckboxInput } from 'components/Shared/dga-checkbox-input/DGACheckboxInput';
import { DGAButton } from 'components/Shared/dga-button/DGAButton';
import DGAInput from 'components/Shared/DGA-inputs/DGA-input';
import Close from 'components/Shared/icons/close';
import React from 'react';

type SidebarFilterProps = {
    fields: {
        Title: {
            value: string;
        },
        SearchBarPlaceholder: {
            value: string;
        },
        NoItemFoundText:{
            value: string;
        };
        FilterTitle: {
            value: string;
        },
        SectorSearchPlaceholder: {
            value: string;
        },
        SectorSearchTitle: {
            value: string;
        },
        ShowAllText: {
            value: string;
        },
        ServiceSearchPlaceholder: {
            value: string;
        },
        ServiceSearchTitle: {
            value: string;
        },
        ClearFilterText: {
            value: string;
        },
        SelectedFilterText: {
            value: string;
        },
        ApplyFilterText : {
            value: string;
        },
        SectorItems:
            {
                id: string;
                url: string;
                name: string;
                displayName: string;
                fields: {
                    Title: {
                        value: string;
                    }
                }
            }[];
        ServiceCategories:
            {
                id: string;
                url: string;
                name: string;
                displayName: string;
                fields:
                {
                    Title: {
                        value: string;
                    };
                    SubItems: {
                        id: string;
                        url: string;
                        name: string;
                        displayName: string;
                        fields: {
                            Title: {
                                value: string
                            }
                        }
                    }[]
                }
            }[],
        ServiceDetailPageLink: {
            value: {
                    href: string;
                    text: string;
                    anchor: string;
                    linktype: string;
                    class: string;
                    title: string;
                    target: string;
                    querystring: string;
                    id: string
                }
        },
        ServicePageHomeBreadcrumbText:{
            value: string;
        }
        ServicePageHomeBreadcrumbLink :{
                value: {
                    href: string;
                    text: string;
                    anchor: string;
                    linktype: string;
                    class: string;
                    title: string;
                    target: string;
                    querystring: string;
                    id: string;
                }
        },
        SortItems:
        {
            id: string;
            url: string;
            name: string;
            displayName: string;
            fields: {
                Title: {
                    value: string;
                },
                value: {
                    value: number;
                }
            }
        }[]
    };
    locale:string;
    selectedSectors: string[];
    setSectors:any;
    selectedServices : string[];
    setServices :any;
    navSectorId:any;
    isApplyfilterClicked:boolean;
    setIsApplyfilterClicked:any;
    setOrder:any;
};

const SidebarFilters = (props: SidebarFilterProps): JSX.Element => {
  let [isLargeScreen, setIsLargeScreen] = useState(true);
  let [showAll,setShowAll] = useState(false);
  let [selectedsectorsLabels, setSelectedSectorsLabels]= useState<string[]>([]);
  let [selectedServiceLabels, setSelectedServiceLabels]= useState<string[]>([]);
  let [filteredSectors, setfilteredSectors] = useState<Sector[]>(props.fields.SectorItems);
  let [filteredServices, setfilteredServices] = useState<Category[]>(props.fields.ServiceCategories);
  let [toggleShowFilter, setToggleShowFilter] = useState(false);
  let [toggleShowSectors, setToggleShowSectors] = useState(false);
  let [toggleShowCategories, setToggleShowCategories] = useState(false);
  const [selectedSortOption, setSelectedSortOption] = useState<any>({
        name: props?.fields?.SortItems[0]?.fields?.Title?.value,
        value: props?.fields?.SortItems[0]?.fields?.value?.value,
  });
  const inputRef2 = React.useRef<any>(null);
  const inputRef3 = React.useRef<any>(null);

  const inputRef4 = React.useRef<any>(null);
  const inputRef5 = React.useRef<any>(null);
  const [searchValue, setSearchValue] = useState("");
  const [searchValue2, setSearchValue2] = useState("");

  useEffect(() => {
    let largeScreenMinLimit = 1024;
    if (window && window?.innerWidth >= largeScreenMinLimit)
        setIsLargeScreen(true);
    else
      setIsLargeScreen(false);
  },[props]);

  useEffect(() => {
    deleteFilters()
    setfilteredSectors(props.fields.SectorItems);
    setfilteredServices(props.fields.ServiceCategories);
  }, [props.locale]);

  
  useEffect(()=>{
    if(props?.navSectorId){
        setShowAll(true);
        setTimeout(()=>{
            let element:any = document.getElementById(props?.navSectorId);
            if(element){
                element.checked=true;
            }
        },10)


        selectedsectorsLabels.push(getSectorName(props?.navSectorId));
    }

  },[props?.navSectorId,props?.locale])

  const setSectorList=(e:any,id:string) =>{
    if (e?.target?.checked && props.selectedSectors.indexOf(id) == -1) {
        props.selectedSectors.push(id);
        selectedsectorsLabels.push(getSectorName(id));
    }
    if (!e?.target?.checked && props.selectedSectors.indexOf(id) != -1) {
        removeSector(id);
    }
    props.setSectors([...props.selectedSectors]);

  }
  
  const setServiceList=(e:any,id:string) =>{
    if(e?.target?.checked && props.selectedServices.indexOf(id) == -1) {
         props.selectedServices.push(id);
         selectedServiceLabels.push(getServiceName(id));
    }
    if (!e?.target?.checked && props.selectedServices.indexOf(id) != -1) {
        removeService(id);
    }
    props.setServices([...props.selectedServices]);
  }

  function changeSortMethod(e:any){
    setSelectedSortOption({name:props?.fields.SortItems[e].fields?.Title?.value, value:props?.fields?.SortItems[e]?.fields?.value?.value})
    props.setOrder(e);
  }

  function getSectorName(id:string)  {
      let name = '';
      props.fields.SectorItems.map((sector) =>{
        if(sector.id === id)
            name = sector.fields.Title.value;

      })
      return name;
  }


  function getServiceName(id:string)  {
    let name = '';
    props?.fields?.ServiceCategories.map(cat =>{
         cat?.fields?.SubItems.map((service:any) =>{
            if(service.id === id)
                name = service.fields.Title.value;
          });
    })
   return name;
  }


  function removeSector(id:string){
    props.selectedSectors.splice(props.selectedSectors.indexOf(id),1 );
    props.setSectors([...props.selectedSectors]);
    selectedsectorsLabels.splice(selectedsectorsLabels.indexOf(getSectorName(id)),1);
    setSelectedSectorsLabels([...selectedsectorsLabels]);
    let element:any = document.getElementById(id)
    element.checked=false;
  }

  function removeService(id:string){
    props.selectedServices.splice(props.selectedServices.indexOf(id),1 );
    props.setServices([...props.selectedServices]);
    selectedServiceLabels.splice(selectedServiceLabels.indexOf(getServiceName(id)),1);
    setSelectedServiceLabels([...selectedServiceLabels]);
    let element:any = document.getElementById(id)
    element.checked=false;
  }


  function deleteFilters(){
    let temp = [...props?.selectedSectors];
    let temp2 = [...props?.selectedServices]
    temp.map(sector =>{
        removeSector(sector);
    });
    temp2.map(service =>{
        removeService(service);
    });
  }

  function searchSector(e:any) {
    setShowAll(true);
    setfilteredSectors([]);
    filteredSectors = [];
    if(e?.target?.value){
        props?.fields?.SectorItems.map(sector =>{
           if(sector?.fields?.Title?.value.toLowerCase().includes(e?.target?.value?.toLowerCase())){
              filteredSectors.push(sector);
           }
        })
        setfilteredSectors([...filteredSectors]);
    } else {
        setfilteredSectors([...props?.fields?.SectorItems]);
        filteredSectors = props?.fields?.SectorItems;
        setTimeout(()=>{
            filteredSectors.map(sector =>{
                if(selectedsectorsLabels.includes(sector.fields?.Title?.value)) {
                    let ele:any = document?.getElementById(sector.id);
                    ele.checked = true;
                } else {
                    let ele:any = document?.getElementById(sector.id);
                    ele.checked = false; 
                }
            })
        },10);

    }

  }

  function searchService(e:any) {
    setfilteredServices([]);
    let x :any[] = [];
    if(e?.target?.value){
        props?.fields?.ServiceCategories.map(service =>{
           let servicePushed = false;
           if(service?.fields?.Title?.value.toLowerCase().includes(e?.target?.value?.toLowerCase())){
             x.push(service);
             servicePushed = true;

           }else {
            service?.fields?.SubItems.map(subItem =>{
                if(subItem?.fields?.Title?.value?.toLowerCase().includes(e?.target?.value)) {
                   if(!servicePushed) {
                    x.push(service);
                    servicePushed = true;
                   }
                }
              });
           }

        });
        setfilteredServices([...x]);
    } else {
        setfilteredServices(props?.fields?.ServiceCategories);
        filteredServices = props?.fields?.ServiceCategories;
        setTimeout(()=>{
            filteredServices.map(service =>{
                service.fields?.SubItems?.map(subCat =>{
                    if(selectedServiceLabels.includes(subCat.fields?.Title?.value)) {  
                        let ele:any = document?.getElementById(subCat.id);
                        if (ele) {
                            ele.checked = true;
                        }
                    } else {
                        let ele:any = document?.getElementById(subCat.id);
                        if (ele) {
                            ele.checked = false;
                        }
                    }
                })
            })
        },100);
    }

  }


  return (
    <>   
        {/* --------------------------------------Desktop View------------------------------------------------- */}
        {isLargeScreen && <div className='sidebar-filter flex flex-col col-span-12 md:col-span-4 lg:col-span-3  '>
             {/*------------- filters title------------------------------------- */}
             <div className='sidebar-title w-full  self-end mt-10 ' >
                <h2 className='text-[32px] text-[#161616] py-2 font-extrabold ' >{props.fields.FilterTitle.value}</h2>
             </div>
            <div className='relative w-full  py-2 px-3 xl:px-6 self-end border-[1px] rounded-md border-[#D2D6DB] max-h-[75vh] overflow-y-auto'>

            {/*---------------selected filters -------------------------------  */}
            { (props.selectedSectors.length|| props.selectedServices.length) ?
             <div className='selected-filters' style={{borderBottomColor: '#969696', borderBottomWidth: '1px'}}>
                <div className="title flex flex-row justify-between items-center">
                <h3 className='text-[16px] text-[#4F5D68] py-2 font-extrabold' >{props.fields.SelectedFilterText.value}</h3>
                {/* <div className="clear-filter text-[#EB5A3C] font-bold cursor-pointer " onClick={()=> deleteFilters()} >{props.fields.ClearFilterText.value}</div> */}
                </div>
                <div className="filter-tags flex flex-row gap-2 flex-wrap my-2">
                    {selectedsectorsLabels.map((sector,index)=>{
                       return(
                        <>
                           <div key={index} className='flex flex-row text-start text-[14px] text-[#9DA4AE] bg-[#F7FDF9] border-[#9DA4AE] border-[1px] rounded-lg p-2' >
                            {sector }
                                <span className={`cursor-pointer ${props.locale == 'en'? 'ml-2':'mr-2'}`} onClick={()=> removeSector(props.selectedSectors[index])} aria-label={`Remove ${sector}`} role="button" tabIndex={0}>
                                   <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                     <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5ZM8 1.56667C4.17083 1.56667 1.06667 4.67083 1.06667 8.5C1.06667 12.3292 4.17083 15.4333 8 15.4333C11.8292 15.4333 14.9333 12.3292 14.9333 8.5C14.9333 4.67083 11.8292 1.56667 8 1.56667ZM7.24575 8.5L4.42288 5.67712L5.17712 4.92288L8 7.74575L10.8229 4.92288L11.5771 5.67712L8.75425 8.5L11.5771 11.3229L10.8229 12.0771L8 9.25425L5.17712 12.0771L4.42288 11.3229L7.24575 8.5Z" fill="#9DA4AE"/>
                                   </svg>
                               </span>
                           </div>
                        </>
                       )
                    })}
                    {selectedServiceLabels.map((service,index)=>{
                       return(
                        <>
                           <div key={index} className='flex flex-row text-start text-[14px] text-[#9DA4AE] bg-[#F7FDF9] border-[#9DA4AE] border-[1px] rounded-lg p-2' >
                            { service }
                                <span className={`cursor-pointer ${props.locale == 'en'? 'ml-2':'mr-2'}`} onClick={()=> removeService(props.selectedServices[index])} aria-label={`Remove ${service}`} role="button" tabIndex={0}>
                                   <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                     <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5ZM8 1.56667C4.17083 1.56667 1.06667 4.67083 1.06667 8.5C1.06667 12.3292 4.17083 15.4333 8 15.4333C11.8292 15.4333 14.9333 12.3292 14.9333 8.5C14.9333 4.67083 11.8292 1.56667 8 1.56667ZM7.24575 8.5L4.42288 5.67712L5.17712 4.92288L8 7.74575L10.8229 4.92288L11.5771 5.67712L8.75425 8.5L11.5771 11.3229L10.8229 12.0771L8 9.25425L5.17712 12.0771L4.42288 11.3229L7.24575 8.5Z" fill="#9DA4AE"/>
                                   </svg>
                               </span>
                           </div>
                        </>
                       )
                    })}
                </div>

              </div> : null }
            {/* --------------------------sectors section ------------------------------- */}
            <div className='filter-group-1'>
                <div className='list-title' >
                    <div className='text-[16px] xl:text-[18px] text-[#161616] py-5 font-bold' >{props.fields.SectorSearchTitle.value}</div>
                </div>

                 <DGAInput type="text" name="searchInput2" ref={inputRef2}  placeholder={props.fields.SectorSearchPlaceholder.value}  InputSize='lg'
                    onChange={async (e) => {  searchSector(e); setSearchValue(e.target.value); }}
                    startIcon={
                        <button
                            type="submit" 
                            aria-label={`${props.fields.SectorSearchTitle?.value || "Search"} (${props.fields.SectorSearchPlaceholder?.value || "filter"})`}
                            className="disabled:opacity-60 disabled:cursor-not-allowed" >
                            <SearchIcon
                                color={"#161616"}
                                classes="w-5 h-5 cursor-pointer"
                                aria-hidden
                            />
                        </button> }
                    endIcon={
                          <button  type="button"
                              onClick={() => {
                                  setSearchValue('')
                                  if (inputRef2.current) {
                                      inputRef2.current.value = '';
                                      inputRef2.current.focus();
                                      // Trigger input event to update any React state
                                      const event = new Event('input', { bubbles: true });
                                      inputRef2.current.dispatchEvent(event);
                                      searchSector('');
                                  }
                              }}
                              aria-label="Clear search"
                          >
                          {searchValue && <Close aria-label="" aria-hidden={true} />}
                        </button> }
                  />
                <div className='sectors-list  py-5 border-b border-neutral-300'>
                   { filteredSectors.map((sector, index ) => {
                    return(
                        (showAll ? 
                        <div  key={index} className=' '>
                            <label htmlFor={sector.id} className={`hover:bg-neutral-100 text-start !flex gap-2 items-center p-2 flex-row`} >
                             
                                <DGACheckboxInput
                                size="sm"
                                className='!min-w-[18px]'
                                id={sector.id}
                                variant="default"
                                checked={props.selectedSectors.includes(sector?.id)}
                                onChange={(e) =>
                                    setSectorList(e,sector.id)
                                }
                               
                                />
                             
                           
                            <div className='text-neutral-800 cursor-pointer text-base' >{sector?.fields?.Title?.value }</div>
                            </label>
                            
                        </div> :  (
                         (index < 7) ? 
                            (<div key={index} className=''>
                                <label htmlFor={sector.id} className={`hover:bg-neutral-100 text-start !flex gap-2 items-center p-2 flex-row`} >
                                   
                                    <DGACheckboxInput
                                        size="sm"
                                        className='!min-w-[18px]'
                                        id={sector.id}
                                        variant="default"
                                        checked={props.selectedSectors.includes(sector?.id)}
                                        onChange={(e) =>
                                            setSectorList(e,sector.id)
                                        }
                                     /> 
                                   
                                    <div className='text-neutral-800 cursor-pointer text-base'   >{sector.fields.Title.value }</div>
                                </label>
                            </div>) : null)
                        ))
                     })
                    }
                    { !showAll && <a className='cursor-pointer text-[14px] text-[#161616]' 
                         onClick={() => setShowAll(true)}>{props?.fields?.ShowAllText?.value + ' (' + props?.fields?.SectorItems?.length +')' }</a>}
                </div>
            </div>
            {/*--------------------category section--------------------------------- */}
            <div className='filter-group-2 ' >
                <div className='list-title' >
                    <div className='text-[16px] xl:text-[18px] text-[#161616] py-5 font-bold' >{props?.fields?.ServiceSearchTitle?.value}</div>
                </div>

                <DGAInput type="text" name="searchInput3" ref={inputRef3}  placeholder={props.fields.SectorSearchPlaceholder.value}  InputSize='lg'
                    onChange={async (e) => { searchService(e); setSearchValue2(e.target.value); }}
                    startIcon={
                        <button
                            type="submit" 
                            aria-label={`${props?.fields?.ServiceSearchTitle?.value || "Search"} (${props.fields.SectorSearchPlaceholder?.value || "filter"})`}
                            className="disabled:opacity-60 disabled:cursor-not-allowed" >
                            <SearchIcon
                                color={"#161616"}
                                classes="w-5 h-5 cursor-pointer"
                                aria-hidden
                            />
                        </button> }
                    endIcon={
                          <button  type="button"
                              onClick={() => {
                                  setSearchValue2('');
                                  if (inputRef3.current) {
                                      inputRef3.current.value = '';
                                      inputRef3.current.focus();
                                      // Trigger input event to update any React state
                                      const event = new Event('input', { bubbles: true });
                                      inputRef3.current.dispatchEvent(event);
                                      searchService('');
                                  }
                              }}
                              aria-label="Clear search"
                          >
                          {searchValue2 && <Close aria-label="" aria-hidden={true} />}
                        </button> }
                />

                {/* ----------------------------------start of categories list------------------------------------------------- */}
                <div className='categories-list  py-5' >
                    { filteredServices.map((category,index) =>{
                        return (
                            <Disclosure key={index}>
                            {({ open }) => (
                            <>
                                <Disclosure.Button className="flex relative w-full justify-between  items-center ">
                                    <div className="panel-header flex flex-row justify-between gap-2 w-full py-3" style={{borderBottomColor: '#E6E6E6', borderBottomWidth: '1px'}}>
                                    <span className="category flex-1 text-[#6E7182] text-[16px] text-start" >
                                        {category?.fields?.Title?.value + ' ('+ category?.fields?.SubItems?.length +')'}
                                    </span>
                                    <div className='w-5 h-5 '>
                                    <ChevronUpIcon
                                        className={`${
                                        open ? "rotate-180 transform" : ""
                                        }  text-[#6E7182]   !opacity-100 relative z-20   `}
                                    />
                                    </div>

                                    </div>

                                </Disclosure.Button>
                                <Disclosure.Panel className=" z-30 relative px-4 pt-6 pb-6 text-sm ">
                                    {/*-------- sub cat list----------- */}
                                    <ul
                                    className={`flex flex-col gap-1 animate-top ${
                                        props?.locale == 'en' ? "pr-4" : "pl-4"
                                    }`}
                                    style={{ listStyleType: "square" }}
                                    >
                                    {category?.fields?.SubItems?.map(
                                        (subCat: any, index: number) => {
                                        return(
                                            <div key={index} className='checkbox-item'>
                                                <label htmlFor={subCat.id} className="hover:bg-neutral-100 text-start !flex gap-2 items-center p-2 flex-row">
                                                    
                                                        <DGACheckboxInput
                                                            size="sm"
                                                            className='!min-w-[18px]'
                                                            id={subCat.id}
                                                            variant="default"
                                                            checked={props.selectedServices.includes(subCat?.id)}
                                                            onChange={(e) =>
                                                                setServiceList(e,subCat.id)
                                                            }
                                                        />
                                                    
                                                        <div  className='text-neutral-800 cursor-pointer text-base'  >{subCat?.fields?.Title?.value }</div>
                                                </label>
                                            </div>
                                        )}
                                        )}
                                    </ul>
                                    {/* -------------------------------- */}
                                </Disclosure.Panel>
                            </>
                            )}
                        </Disclosure>
                        )
                    })}

                </div>
                {/*----------------------------------- end of categories list-------------------------------------------------- */}
            </div>
             {/* ------------------------------------------------------------------- */}


            </div>
            {/* ----------------------------------apply filter btn --------------------------------------------------------- */}
            <div className='apply-filter-section flex justify-end gap-2 py-2  w-full  self-end mb-6'>
                <DGAButton className='!w-[50%] !whitespace-nowrap' type="submit"
                    buttonContent={<>{props?.fields?.ApplyFilterText?.value}
                    <span>{(props.selectedSectors.length || props.selectedServices.length) ?
                     (' (' + (props.selectedSectors.length + props.selectedServices.length) + ')' ) : null}</span></>}
                    onClick={()=> props?.setIsApplyfilterClicked(true)} size="lg" variant="primary"/>
                 <DGAButton className='!w-[50%]  !whitespace-nowrap' type="submit"
                    buttonContent={props?.fields?.ClearFilterText?.value}
                    onClick={()=> deleteFilters()} size="lg" variant='secondarySolid' />
            </div>
            {/* ------------------------------------------------------------------------------------------------------------- */}
        </div>}
        {/* ---------------------------------------Mobile View ------------------------------------------------- */}
        {!isLargeScreen && <div className='col-span-12 p-2 responsive'>
          <div className='sidebar-filter flex flex-col   w-full '>  
            <div className='sidebar-title' >
                {/*------------- filters title------------------------------------- */}
                <h2 className='text-[30px] text-[#161616] py-4 font-extrabold' >{props.fields.FilterTitle.value}</h2>
                <div className='filter-and-sort-btns mb-2 flex gap-2'>
                    {/* -------------------------------show filter toggle ---------------------------- */}
                    <button onClick={()=> setToggleShowFilter(!toggleShowFilter)} className='cursor-pointer bg-[#0D121C] rounded-lg px-4 py-2 text-white flex gap-2 ' aria-label={`${toggleShowFilter ? 'Hide' : 'Show'} filters`}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                           <path fill-rule="evenodd" clip-rule="evenodd" d="M4.18213 0.250002C4.19946 0.250002 4.21686 0.250003 4.23431 0.250003L15.8178 0.250002C16.5884 0.249966 17.2426 0.249936 17.7587 0.320304C18.3049 0.394785 18.8273 0.562914 19.2272 1.0031C19.6306 1.44714 19.741 1.98226 19.7494 2.52927C19.7573 3.04013 19.6757 3.67472 19.5805 4.41461L19.5735 4.4685C19.5399 4.73033 19.4893 4.98356 19.384 5.23711C19.2771 5.49453 19.1298 5.71377 18.9464 5.93165C17.9667 7.09554 16.1454 9.1989 13.5814 11.1144C13.54 11.1454 13.4876 11.2188 13.4776 11.329C13.2285 14.0819 13.0094 15.5385 12.8513 16.3823C12.6803 17.2948 11.9843 17.9264 11.3841 18.3612C11.0701 18.5888 10.7367 18.7937 10.4398 18.9744C10.416 18.9889 10.3925 19.0032 10.3693 19.0173C10.0919 19.186 9.8561 19.3294 9.659 19.4687C9.11849 19.8509 8.49491 19.8241 8.01827 19.5464C7.56847 19.2844 7.25196 18.8065 7.18796 18.266C7.0475 17.0796 6.79286 14.7569 6.51176 11.3226C6.50274 11.2124 6.48553 11.1805 6.4841 11.1778C6.48311 11.1759 6.48058 11.1713 6.47219 11.1621C6.4628 11.1517 6.44403 11.1335 6.40835 11.1068C3.84952 9.19368 2.03182 7.094 1.05351 5.93162C0.870802 5.71453 0.71921 5.50051 0.611123 5.24022C0.505311 4.98541 0.460192 4.73089 0.42644 4.46849C0.424121 4.45047 0.421809 4.43251 0.419505 4.4146C0.324289 3.67472 0.242623 3.04013 0.25053 2.52927C0.258998 1.98226 0.369419 1.44714 0.772804 1.0031C1.17269 0.562914 1.69502 0.394785 2.2413 0.320304C2.75741 0.249936 3.41157 0.249966 4.18213 0.250002ZM2.44394 1.80655C2.05984 1.85892 1.94414 1.94449 1.88307 2.01171C1.82551 2.07507 1.75601 2.18665 1.75035 2.55249C1.74432 2.94212 1.81012 3.46812 1.91418 4.27712C1.9431 4.50193 1.96843 4.59754 1.99643 4.66496C2.02215 4.72691 2.06773 4.80722 2.20114 4.96572C3.15942 6.10431 4.88846 8.09756 7.30654 9.90542C7.50081 10.0507 7.67905 10.2305 7.808 10.4726C7.93505 10.7112 7.98704 10.9594 8.00676 11.2002C8.28632 14.6158 8.53914 16.9204 8.67756 18.0896C8.68178 18.1253 8.69476 18.1604 8.71474 18.1911C8.73518 18.2224 8.75789 18.2413 8.77333 18.2503C8.7753 18.2515 8.77703 18.2524 8.77851 18.2531C8.78207 18.2512 8.78688 18.2483 8.79298 18.244C9.03509 18.0728 9.3161 17.902 9.58133 17.7409C9.60774 17.7248 9.63398 17.7089 9.66002 17.693C9.95883 17.5112 10.2446 17.3345 10.504 17.1466C11.0508 16.7503 11.319 16.4151 11.3769 16.1061C11.5234 15.3243 11.7372 13.9181 11.9837 11.1938C12.0289 10.6947 12.274 10.2188 12.6837 9.91271C15.1067 8.10253 16.8392 6.10571 17.7988 4.9657C17.9152 4.82745 17.9669 4.73831 17.9988 4.6616C18.0323 4.58102 18.0604 4.4744 18.0858 4.27712C18.1899 3.46812 18.2557 2.94212 18.2496 2.55249C18.244 2.18665 18.1745 2.07507 18.1169 2.01171C18.0558 1.94449 17.9401 1.85892 17.556 1.80655C17.1534 1.75165 16.6027 1.75 15.7657 1.75H4.23431C3.39726 1.75 2.8466 1.75165 2.44394 1.80655ZM8.77065 18.2566C8.77069 18.2566 8.77118 18.2564 8.77211 18.2562L8.77065 18.2566Z" fill="white"/>
                        </svg>
                       {props.fields.FilterTitle.value}
                    </button>
                    {/* ----------------------------------sort dropdown-------------------------------- */}
                    <div className='w-fit relative '>
                        <Listbox value={selectedSortOption.value} onChange={(e) => changeSortMethod(e)}>
                            {({ open }) => (
                            <>
                                <Listbox.Button
                                className={
                                    "relative min-w-[100px] text-brand-100 p-2 md:px-8 md:py-4 bg-brand-transparent bg-[#F3F4F6] border rounded-lg flex gap-3 items-center max-h-[45px] h-full"
                                }
                                >
                                {selectedSortOption
                                    ? selectedSortOption.name
                                    : props?.fields?.SortItems[0].fields.Title.value}
                                    <svg className={`transition-transform duration-300 ease-in-out ${open ? "rotate-180" : "" }`} width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                                        <path d="M1.5031 1.1294C1.60467 1.26388 1.90793 1.66534 2.08853 1.89676C2.45026 2.36027 2.94452 2.97618 3.47769 3.59026C4.01356 4.20744 4.57648 4.80852 5.07658 5.25039C5.32734 5.47195 5.54762 5.64031 5.72939 5.74989C5.90035 5.85296 6.00134 5.87439 6.00134 5.87439C6.00134 5.87439 6.09936 5.85295 6.27031 5.7499C6.45209 5.64032 6.67237 5.47196 6.92313 5.25039C7.42322 4.80852 7.98615 4.20744 8.52201 3.59025C9.05518 2.97616 9.54944 2.36025 9.91117 1.89673C10.0918 1.66531 10.3946 1.26442 10.4962 1.12994C10.7009 0.852004 11.0925 0.792058 11.3705 0.996751C11.6484 1.20145 11.7078 1.59269 11.5031 1.87063L11.5015 1.87273C11.395 2.01376 11.0809 2.42963 10.8966 2.66577C10.5267 3.13975 10.018 3.77384 9.46589 4.40976C8.91646 5.04257 8.31173 5.69149 7.7508 6.18712C7.47105 6.4343 7.18747 6.65656 6.91567 6.82042C6.66102 6.97393 6.33861 7.125 5.99985 7.125C5.66109 7.125 5.33868 6.97393 5.08404 6.82041C4.81223 6.65656 4.52866 6.4343 4.24891 6.18712C3.68798 5.69149 3.08325 5.04258 2.53382 4.40977C1.98169 3.77386 1.473 3.13978 1.1031 2.6658C0.918709 2.42953 0.60464 2.01371 0.4983 1.87292L0.4969 1.87107C0.292204 1.59313 0.351284 1.20149 0.629218 0.996793C0.907143 0.792105 1.2984 0.851493 1.5031 1.1294Z" fill="#161616"/>
                                    </svg>
    
                                </Listbox.Button>
                                <Listbox.Options
                                className={"  absolute top-11 z-30    bg-white w-full shadow-md border rounded-lg"}
                                >
                                {props?.fields.SortItems.map((item,index) => (
                                    <Listbox.Option key={item.id} value={item.fields.value.value}>
                                    {({ active }) => (
                                        <li
                                        className={`cursor-pointer text-[#5E5E5E] py-1 ${active ? "bg-[#E7E7E7] !text-[#6C737F]" : "bg-white"
                                            } ${props?.locale == 'ar' ? "pr-2 md:pr-4" : "pl-2 md:pl-4"}`} style={{borderBottomLeftRadius: (index == props?.fields?.SortItems?.length - 1 )? '16px':'0px', borderBottomRightRadius: (index == props?.fields?.SortItems?.length - 1 )? '16px':'0px'}}>
                                        {item.fields.Title.value}
                                        </li>
                                    )}
                                    </Listbox.Option>
                                ))}
                                </Listbox.Options>
                            </>
                            )}
                        </Listbox>
                    </div>
                </div>
            </div>
            {toggleShowFilter && <div className='relative w-full md:w-[80%] md:py-10 py-5 px-6 self-end border-[1px] rounded-md border-[#D2D6DB]  max-h-[75vh] overflow-y-auto'>

                {/*---------------selected filters -------------------------------  */}
                { (props.selectedSectors.length|| props.selectedServices.length) ?
                <div className='selected-filters' style={{borderBottomColor: '#969696', borderBottomWidth: '1px'}}>
                    <div className="title flex flex-row justify-between items-center">
                    <h3 className='text-[16px] text-[#4F5D68] py-2 font-extrabold' >{props.fields.SelectedFilterText.value}</h3>
                    {/* <div className="clear-filter text-[#EB5A3C] font-bold cursor-pointer " onClick={()=> deleteFilters()} >{props.fields.ClearFilterText.value}</div> */}
                    </div>
                    <div className="filter-tags flex flex-row gap-2 flex-wrap my-2">
                        {selectedsectorsLabels.map((sector,index)=>{
                        return(
                            <>
                            <div key={index} className='flex flex-row text-start text-[14px] text-[#9DA4AE] bg-[#F7FDF9] border-[#9DA4AE] border-[1px] rounded-lg p-2' >
                                {sector }
                                    <span className={`cursor-pointer ${props.locale == 'en'? 'ml-2':'mr-2'}`} onClick={()=> removeSector(props.selectedSectors[index])}>
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5ZM8 1.56667C4.17083 1.56667 1.06667 4.67083 1.06667 8.5C1.06667 12.3292 4.17083 15.4333 8 15.4333C11.8292 15.4333 14.9333 12.3292 14.9333 8.5C14.9333 4.67083 11.8292 1.56667 8 1.56667ZM7.24575 8.5L4.42288 5.67712L5.17712 4.92288L8 7.74575L10.8229 4.92288L11.5771 5.67712L8.75425 8.5L11.5771 11.3229L10.8229 12.0771L8 9.25425L5.17712 12.0771L4.42288 11.3229L7.24575 8.5Z" fill="#9DA4AE"/>
                                    </svg>
                                </span>
                            </div>
                            </>
                        )
                        })}
                        {selectedServiceLabels.map((service,index)=>{
                        return(
                            <>
                            <div key={index} className='flex flex-row text-start text-[14px] text-[#9DA4AE] bg-[#F7FDF9] border-[#9DA4AE] border-[1px] rounded-lg p-2' >
                                { service }
                                    <span className={`cursor-pointer ${props.locale == 'en'? 'ml-2':'mr-2'}`} onClick={()=> removeService(props.selectedServices[index])}>
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5ZM8 1.56667C4.17083 1.56667 1.06667 4.67083 1.06667 8.5C1.06667 12.3292 4.17083 15.4333 8 15.4333C11.8292 15.4333 14.9333 12.3292 14.9333 8.5C14.9333 4.67083 11.8292 1.56667 8 1.56667ZM7.24575 8.5L4.42288 5.67712L5.17712 4.92288L8 7.74575L10.8229 4.92288L11.5771 5.67712L8.75425 8.5L11.5771 11.3229L10.8229 12.0771L8 9.25425L5.17712 12.0771L4.42288 11.3229L7.24575 8.5Z" fill="#9DA4AE"/>
                                    </svg>
                                </span>
                            </div>
                            </>
                        )
                        })}
                    </div>

                </div> : null }
                {/* --------------------------sectors section ------------------------------- */}
                <div className='filter-group-1'>
                    <div className='list-title' >
                        <button type="button" onClick={()=> setToggleShowSectors(!toggleShowSectors)} className='cursor-pointer text-[18px] text-[#161616] py-3 font-bold flex justify-between items-center w-full text-left bg-transparent border-0' >
                            {props.fields.SectorSearchTitle.value}
                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                            <path d="M2.5031 1.1294C2.60467 1.26388 2.90793 1.66534 3.08853 1.89676C3.45026 2.36027 3.94452 2.97618 4.47769 3.59026C5.01356 4.20744 5.57648 4.80852 6.07658 5.25039C6.32734 5.47195 6.54762 5.64031 6.72939 5.74989C6.90035 5.85296 7.00134 5.87439 7.00134 5.87439C7.00134 5.87439 7.09936 5.85295 7.27031 5.7499C7.45209 5.64032 7.67237 5.47196 7.92313 5.25039C8.42322 4.80852 8.98615 4.20744 9.52201 3.59025C10.0552 2.97616 10.5494 2.36025 10.9112 1.89673C11.0918 1.66531 11.3946 1.26442 11.4962 1.12994C11.7009 0.852004 12.0925 0.792058 12.3705 0.996751C12.6484 1.20145 12.7078 1.59269 12.5031 1.87063L12.5015 1.87273C12.395 2.01376 12.0809 2.42963 11.8966 2.66577C11.5267 3.13975 11.018 3.77384 10.4659 4.40976C9.91646 5.04257 9.31173 5.69149 8.7508 6.18712C8.47105 6.4343 8.18747 6.65656 7.91567 6.82042C7.66102 6.97393 7.33861 7.125 6.99985 7.125C6.66109 7.125 6.33868 6.97393 6.08404 6.82041C5.81223 6.65656 5.52866 6.4343 5.24891 6.18712C4.68798 5.69149 4.08325 5.04258 3.53382 4.40977C2.98169 3.77386 2.473 3.13978 2.1031 2.6658C1.91871 2.42953 1.60464 2.01371 1.4983 1.87292L1.4969 1.87107C1.2922 1.59313 1.35128 1.20149 1.62922 0.996793C1.90714 0.792105 2.2984 0.851493 2.5031 1.1294Z" fill="#161616" stroke="#161616" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                    {toggleShowSectors && <>

                        <DGAInput type="text" name="searchInput4" ref={inputRef4}  placeholder={props.fields.SectorSearchPlaceholder.value}  InputSize='lg'
                            onChange={async (e) => { searchSector(e); setSearchValue(e.target.value); }}
                            startIcon={
                                <button
                                    type="submit" 
                                    aria-label={`${props.fields.SectorSearchTitle?.value || "Search"} (${props.fields.SectorSearchPlaceholder?.value || "filter"})`}
                                    className="disabled:opacity-60 disabled:cursor-not-allowed" >
                                    <SearchIcon
                                        color={"#161616"}
                                        classes="w-5 h-5 cursor-pointer"
                                        aria-hidden
                                    />
                                </button> }
                            endIcon={
                                <button  type="button"
                                    onClick={() => {
                                        setSearchValue('');
                                        if (inputRef4.current) {
                                            inputRef4.current.value = '';
                                            inputRef4.current.focus();
                                            // Trigger input event to update any React state
                                            const event = new Event('input', { bubbles: true });
                                            inputRef4.current.dispatchEvent(event);
                                            searchSector('')
                                        }
                                    }}
                                    aria-label="Clear search"
                                >
                                {searchValue && <Close aria-label="" aria-hidden={true} />}
                                </button> }
                        />
                        <div className='sectors-list  py-5 border-b border-neutral-300'>
                        { filteredSectors.map((sector, index ) => {
                            return(
                                (showAll ? 
                                <div  key={index} className='checkbox-item mb-3 '>
                                    <label htmlFor={sector.id} className={`hover:bg-neutral-100 text-start !flex gap-2 items-center p-2 flex-row`} >
                                       
                                            <DGACheckboxInput
                                                size="sm"
                                                className='!min-w-[18px]'
                                                id={sector.id}
                                                variant="default"
                                                checked={props.selectedSectors.includes(sector?.id)}
                                                onChange={(e) =>
                                                    setSectorList(e,sector.id)
                                                }
                                            />
                                        
                                            <div className='text-neutral-800 cursor-pointer text-base' >{sector?.fields?.Title?.value }</div>
                                    </label>
                                </div> :  (
                                (index < 7) ? 
                                    (<div key={index} className='checkbox-item mb-3'>
                                        <label htmlFor={sector.id} className={`hover:bg-neutral-100 text-start !flex gap-2 items-center p-2 flex-row`} >
                                            
                                                <DGACheckboxInput
                                                    size="sm"
                                                    className='!min-w-[18px]'
                                                    id={sector.id}
                                                    variant="default"
                                                    checked={props.selectedSectors.includes(sector?.id)}
                                                    onChange={(e) =>
                                                        setSectorList(e,sector.id)
                                                    }
                                                />
                                            
                                               <div className='text-neutral-800 cursor-pointer text-base' >{sector.fields.Title.value }</div>
                                        </label>
                                    </div>) : null)
                                ))
                            })
                            }
                            { !showAll && <a className='cursor-pointer text-[14px] text-[#161616]' 
                                onClick={() => setShowAll(true)}>{props?.fields?.ShowAllText?.value + ' (' + props?.fields?.SectorItems?.length +')' }</a>}
                        </div>
                    </>}
                </div>
                {/*--------------------category section--------------------------------- */}
                <div className='filter-group-2 ' >
                    <div className='list-title' >
                        <button type="button" onClick={()=> setToggleShowCategories(!toggleShowCategories)} className='cursor-pointer text-[18px] text-[#161616] py-6 font-bold flex justify-between items-center w-full text-left bg-transparent border-0' >
                            {props?.fields?.ServiceSearchTitle?.value}
                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                            <path d="M2.5031 1.1294C2.60467 1.26388 2.90793 1.66534 3.08853 1.89676C3.45026 2.36027 3.94452 2.97618 4.47769 3.59026C5.01356 4.20744 5.57648 4.80852 6.07658 5.25039C6.32734 5.47195 6.54762 5.64031 6.72939 5.74989C6.90035 5.85296 7.00134 5.87439 7.00134 5.87439C7.00134 5.87439 7.09936 5.85295 7.27031 5.7499C7.45209 5.64032 7.67237 5.47196 7.92313 5.25039C8.42322 4.80852 8.98615 4.20744 9.52201 3.59025C10.0552 2.97616 10.5494 2.36025 10.9112 1.89673C11.0918 1.66531 11.3946 1.26442 11.4962 1.12994C11.7009 0.852004 12.0925 0.792058 12.3705 0.996751C12.6484 1.20145 12.7078 1.59269 12.5031 1.87063L12.5015 1.87273C12.395 2.01376 12.0809 2.42963 11.8966 2.66577C11.5267 3.13975 11.018 3.77384 10.4659 4.40976C9.91646 5.04257 9.31173 5.69149 8.7508 6.18712C8.47105 6.4343 8.18747 6.65656 7.91567 6.82042C7.66102 6.97393 7.33861 7.125 6.99985 7.125C6.66109 7.125 6.33868 6.97393 6.08404 6.82041C5.81223 6.65656 5.52866 6.4343 5.24891 6.18712C4.68798 5.69149 4.08325 5.04258 3.53382 4.40977C2.98169 3.77386 2.473 3.13978 2.1031 2.6658C1.91871 2.42953 1.60464 2.01371 1.4983 1.87292L1.4969 1.87107C1.2922 1.59313 1.35128 1.20149 1.62922 0.996793C1.90714 0.792105 2.2984 0.851493 2.5031 1.1294Z" fill="#161616" stroke="#161616" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                    {toggleShowCategories && <>
                        <DGAInput type="text" name="searchInput5" ref={inputRef5}  placeholder={props.fields.SectorSearchPlaceholder.value}  InputSize='lg'
                            onChange={async (e) => { searchService(e); setSearchValue2(e.target.value); }}
                            startIcon={
                                <button
                                    type="submit" 
                                    aria-label={`${props?.fields?.ServiceSearchTitle?.value || "Search"} (${props.fields.SectorSearchPlaceholder?.value || "filter"})`}
                                    className="disabled:opacity-60 disabled:cursor-not-allowed" >
                                    <SearchIcon
                                        color={"#161616"}
                                        classes="w-5 h-5 cursor-pointer"
                                        aria-hidden
                                    />
                                </button> }
                            endIcon={
                                <button  type="button"
                                    onClick={() => {
                                        setSearchValue2('');
                                        if (inputRef5.current) {
                                            inputRef5.current.value = '';
                                            inputRef5.current.focus();
                                            // Trigger input event to update any React state
                                            const event = new Event('input', { bubbles: true });
                                            inputRef5.current.dispatchEvent(event);
                                            searchService('');
                                        }
                                        
                                    }}
                                    aria-label="Clear search"
                                >
                                 {searchValue2 && <Close aria-label="" aria-hidden={true} />}
                                </button> }
                        />
                        {/* ----------------------------------start of categories list------------------------------------------------- */}
                        <div className='categories-list  py-5' >
                            { filteredServices.map((category,index) =>{
                                return (
                                    <Disclosure key={index}>
                                    {({ open }) => (
                                    <>
                                        <Disclosure.Button className="flex relative w-full justify-between  items-center ">
                                            <div className="panel-header flex flex-row justify-between gap-2 w-full py-3" style={{borderBottomColor: '#E6E6E6', borderBottomWidth: '1px'}}>
                                            <span className="category flex-1 text-[#6E7182] text-[16px] text-start" >
                                                {category?.fields?.Title?.value + ' ('+ category?.fields?.SubItems?.length +')'}
                                            </span>
                                            <div className='w-5 h-5 '>
                                            <ChevronUpIcon
                                                className={`${
                                                open ? "rotate-180 transform" : ""
                                                }  text-[#6E7182]   !opacity-100 relative z-20   `}
                                            />
                                            </div>

                                            </div>

                                        </Disclosure.Button>
                                        <Disclosure.Panel className=" z-30 relative px-4 pt-6 pb-6 text-sm ">
                                            {/*-------- sub cat list----------- */}
                                            <ul
                                            className={`flex flex-col gap-2 animate-top ${
                                                props?.locale == 'en' ? "pr-4" : "pl-4"
                                            }`}
                                            style={{ listStyleType: "square" }}
                                            >
                                            {category?.fields?.SubItems?.map(
                                                (subCat: any, index: number) => {
                                                return(
                                                    <div key={index} className='checkbox-item'>
                                                    <label htmlFor={subCat.id} className="hover:bg-neutral-100 text-start !flex gap-2 items-center p-2 flex-row">
                                                        
                                                            <DGACheckboxInput
                                                                size="sm"
                                                                className='!min-w-[18px]'
                                                                id={subCat.id}
                                                                variant="default"
                                                                checked={props.selectedServices.includes(subCat?.id)}
                                                                onChange={(e) =>
                                                                    setServiceList(e,subCat.id)
                                                                }
                                                             />

                                                             <div className='text-neutral-800 cursor-pointer text-base' >{subCat?.fields?.Title?.value }</div>
                                                    </label>
                                                    </div>
                                                )}
                                                )}
                                            </ul>
                                            {/* -------------------------------- */}
                                        </Disclosure.Panel>
                                    </>
                                    )}
                                </Disclosure>
                                )
                            })}

                        </div>
                        {/*----------------------------------- end of categories list-------------------------------------------------- */}
                    </>}
                </div>

            </div>}

            {/* ----------------------------------apply filter btn --------------------------------------------------------- */}
            {toggleShowFilter && <div className='apply-filter-section flex justify-end gap-2 py-2  !w-full self-end mb-6'>
              
                <DGAButton className='!w-[50%]' type="submit"
                    buttonContent={<>{props?.fields?.ApplyFilterText?.value}
                    <span>{(props.selectedSectors.length || props.selectedServices.length) ?
                     (' (' + (props.selectedSectors.length + props.selectedServices.length) + ')' ) : null}</span></>}
                    onClick={()=> props?.setIsApplyfilterClicked(true)} size="lg" variant="primary"/>
                 <DGAButton className='!w-[50%]' type="submit"
                    buttonContent={props?.fields?.ClearFilterText?.value}
                    onClick={()=> deleteFilters()} size="lg" variant='secondarySolid' />
                
            </div>}
            {/* ------------------------------------------------------------------------------------------------------------- */}
          </div>
        </div>}
    </>
  )
}
export default SidebarFilters

type Category = {
    id: string;
    url: string;
    name: string;
    displayName: string;
    fields:
    {
        Title: {
            value: string;
        };
        SubItems: {
            id: string;
            url: string;
            name: string;
            displayName: string;
            fields: {
                Title: {
                    value: string
                }
            }
        }[]
    }
}

type Sector = {
    id: string;
    url: string;
    name: string;
    displayName: string;
    fields: {
        Title: {
            value: string;
        }
    }
}